
/**
 * Just in case a full url has been entered, convert it to just the query string
 * @param  {String} href
 * @return {String}
 */
const hrefToQueryString = (href) => {
  try {
    const url = new URL(href);
    return url.search;
  } catch (e) {
    return href;
  }
};

/**
 * search current url for a given query string
 * @param  {String} key         query string identifier
 * @param  {String} _queryString overriden url query string to search
 * @return {String}             query string value, default empty string
 */
const getUrlParameter = (key, _queryString) => {
  const queryString = hrefToQueryString(_queryString);
  try {
    const searchParams = new URLSearchParams(queryString || window.location.search);

    const value = searchParams.get(key);

    if (value && key === 'page') {
      return Number(value) || 0;
    }

    return value || '';
  } catch (e) {
    console.error(e); // eslint-disable-line no-console

    // Fallback to old regex method
    const escapedKey = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&#]${escapedKey}=([^&#]*)`);
    const results = regex.exec(queryString || window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};

export default getUrlParameter;
